import { useState, useEffect } from 'react'

export const useFetchCategories = ({marvarApi, dispatch, onLogout}) => {

    // 1. Para los datos recuperados de la BD
    const [ dataCategories, setDataCategories ] = useState([])
    
    // 2. Para mostrar animación de carga
    const [ loadingFetchAllCategories, setLoadingFetchAllCategories ] = useState(false)

    // 3. Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            
            const response = await marvarApi.get(`/cashier-managements/categories`)
            // console.log('[useFetch][useFetchCategories] response.data :::', response.data)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        setLoadingFetchAllCategories(true)
        fetchData()
            .then((resp) => {
                setDataCategories(resp.rows)
                setLoadingFetchAllCategories(false)
            })
            .catch(e => {
                console.log(e, '________ERROR')
                setLoadingFetchAllCategories(false)
            })
    }, [execute])

    return {  dataCategories, loadingFetchAllCategories , executeFetch }

}

export const useFetchAllCashRegisters = ({ marvarApi, dispatch, onLogout, user }) => {

    const _defaultParams = {
        idcategoria: '',
        currency_type: '',
    }
    const [ paramsToSearch, setParamsToSearch ] = useState(_defaultParams)

    const [ dataCashRegisters, setDataCashRegisters ] = useState([])

    const [ loadingFetchCashRegisters, setLoadingFetchCashRegisters ] = useState(false)

    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }

    const resetFetch = async () => {
        setDataCashRegisters([])
        setParamsToSearch(_defaultParams)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            const _body = {
                idcategoria: parseInt(paramsToSearch.idcategoria, 10),
                currency_type: String(paramsToSearch.currency_type),
                idusuario: user.uid,
            }
            const response = await marvarApi.post(`/caja/assigned-cashiers`, _body)
            console.log('[useFetchData][useFetchAllCashRegisters] response.data ::: ', response.data)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if (
            paramsToSearch.idcategoria > 0 
            && paramsToSearch.idcategoria !== ''
            && paramsToSearch.currency_type !== ''
        ) {
            setLoadingFetchCashRegisters(true)
            fetchData()
                .then((resp) => {
                    setDataCashRegisters(resp.rows)
                    setLoadingFetchCashRegisters(false)
                })
                .catch(e => {
                    console.log(e, '________ERROR')
                    setLoadingFetchCashRegisters(false)
                })
        }
    }, [execute])

    return { dataCashRegisters, loadingFetchCashRegisters, setParamsToSearch, executeFetch, resetFetch }
}

export const useFetchTransactionsReport = ({ marvarApi, dispatch, onLogout }) => {
    const defaultParams = {
        startDate: '',
        endDate: '',
        idcaja: '',
        movimiento_tipo: 'ALL'
    }

    const [paramsToSearch, setParamsToSearch] = useState(defaultParams)
    const [dataPdfTransactionsReport, setDataPdfTransactionsReport] = useState('')

    const [loadingFetchAllTransactionsReport, setLoadingFetchTransactionsReport] = useState(false)

    const [execute, setExecute] = useState(false)
    const executeFetch = async () => setExecute(!execute)

    const resetFetch = async () => {
        setParamsToSearch(defaultParams)
        setDataPdfTransactionsReport('')
    }

    const fetchData = async () => {
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        const _dataBody = {
            startDate: paramsToSearch.startDate,
            endDate: paramsToSearch.endDate,
            idcaja: paramsToSearch.idcaja,
            movimiento_tipo: paramsToSearch.movimiento_tipo
        }

        const response = await marvarApi.post(`/cash-movement/fetch-transactions-report`, _dataBody, {
            responseType: 'blob'
        })
        console.log('[useFetchData][useFetchTransactionsReport] response.data ::: ', response.data)
        return response.data
    }

    useEffect(() => {
        if (!paramsToSearch.startDate || !paramsToSearch.endDate ) return

        setDataPdfTransactionsReport('')
        setLoadingFetchTransactionsReport(true)

        fetchData()
            .then(async (resp) => {
                if (resp?.type.includes('application/pdf')) {
                    setDataPdfTransactionsReport(URL.createObjectURL(resp))
                } else if (resp?.type.includes('application/json')) {
                    const data = JSON.parse(await resp.text())
                    setDataPdfTransactionsReport(data)
                }

                setLoadingFetchTransactionsReport(false)
            })
            .catch((e) => {
                console.log(e, '________ERROR')
                setDataPdfTransactionsReport('')
                setLoadingFetchTransactionsReport(false)
            })
    }, [execute])

    useEffect(() => {
        return () => {
            if (typeof dataPdfTransactionsReport === 'string' && dataPdfTransactionsReport) {
                URL.revokeObjectURL(dataPdfTransactionsReport)
            }
        }
    }, [dataPdfTransactionsReport])

    return { dataPdfTransactionsReport, loadingFetchAllTransactionsReport, setParamsToSearch, executeFetch, resetFetch }
}

